/* src/app/google-translate/google-translate.component.css */
.translate-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
  margin: 0;
  padding: 0;
}
.translate-icon {
  font-size: 18px;
  color: white;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  height: 32px;
  margin: 0;
  padding: 0;
}
#google_translate_element {
  height: 32px !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}
.goog-te-combo {
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 8px !important;
  margin: 0 !important;
  vertical-align: middle !important;
  font-size: 13px !important;
  border-radius: 4px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  background: transparent !important;
  color: #FFF !important;
  opacity: 1 !important;
  visibility: visible !important;
  display: inline-block !important;
}
.translate-container .goog-te-combo option {
  background-color: #004C4A !important;
  color: #FFFFFF !important;
}
.goog-te-combo:hover {
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.goog-te-combo:focus,
.goog-te-combo:focus-visible,
.goog-te-combo:active {
  border-color: rgba(255, 255, 255, 0.6) !important;
  outline: 2px solid rgba(255, 255, 255, 0.35) !important;
  outline-offset: 1px !important;
  box-shadow: none !important;
}
@media (max-width: 600px) {
  .translate-container {
    height: 24px;
    gap: 6px;
    align-items: center;
    display: flex;
    margin: 0;
    padding: 0;
  }
  .translate-icon {
    height: 24px;
    font-size: 16px;
    line-height: 1;
    margin: 0;
    padding: 0;
  }
  #google_translate_element {
    height: 24px !important;
    line-height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
  }
  .goog-te-gadget {
    height: 24px !important;
    display: inline-flex !important;
    align-items: center !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .goog-te-combo {
    height: 24px !important;
    line-height: 24px !important;
    padding: 0 4px !important;
    margin: 0 !important;
    vertical-align: middle !important;
    font-size: 12px !important;
    border-radius: 4px !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    background: transparent !important;
    color: #FFF !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: inline-block !important;
  }
}
.goog-logo-link {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
}
.goog-te-gadget-simple {
  font-size: 0 !important;
}
.goog-te-ft {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  overflow: hidden !important;
}
#goog-gt-tt {
  display: none !important;
}
.goog-te-gadget-simple::before {
  content: "" !important;
}
.goog-te-gadget-simple::after {
  content: "" !important;
}
.goog-te-gadget {
  color: #FFF !important;
  height: 32px !important;
  vertical-align: middle !important;
  display: inline-flex !important;
  align-items: center !important;
  margin: 0 !important;
  padding: 0 !important;
}
.translate-container .goog-te-gadget {
  font-size: 0 !important;
}
.translate-container .goog-te-gadget .goog-te-combo {
  font-size: 13px !important;
}
@media (max-width: 600px) {
  .translate-container .goog-te-gadget .goog-te-combo {
    font-size: 12px !important;
  }
}
/*# sourceMappingURL=google-translate.component-22KOTRJS.css.map */
